import { User } from "../models/user.model";

export const TokenStorage = {
    setTokens: (token: string, refreshToken: string, user: User) => {
        localStorage.setItem('token', token);
        localStorage.setItem('refreshToken', refreshToken);
        localStorage.setItem('user', JSON.stringify(user));
    },
    
    getTokens: () => ({
        token: localStorage.getItem('token') || '',
        refreshToken: localStorage.getItem('refreshToken') || '',
        user: JSON.parse(localStorage.getItem('user') || 'null')
    }),
    
    clearTokens: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
    }
}; 